import { googleAnalyticsParamEvent, googleAnalyticsEvent } from '../utils/googleAnalyticsEvents';
import router from "@/router";


const evt = 'lgfamilyclub'
const basePath = import.meta.env.VITE_BASE_PATH

export const route = {
  namespaced: true,
  actions: {
    click({ rootState, dispatch }, { to, element, content, index, forceRedirect }) {
      if (Object.prototype.toString.call(to) === '[object Object]')
        to = router.resolve(to).path

      try {
        if (forceRedirect && to) {
          const toForGa = to.indexOf(basePath) >= 0 ? to.substring(to.indexOf(basePath) + basePath.length) : to
          return dispatch('gaEvent', { element, content, index, to: window.location.host + toForGa }).then(() => {
            router.push(to)
          })
        }
        if (rootState.auth.user) {
          if (to.indexOf('lgfamilyclub.com') < 0 && to.indexOf('/') !== 0) {
            if (to.indexOf('https://') < 0) to = 'https://' + to
            dispatch('gaEvent', { element, content, index, to }).then(() => {
              window.open(to, (this.isTabSelf ? '_self' : '_blank'))
            })
          } else if ([router.resolve({ name: 'signin' }).path, router.resolve({ name: 'signup' }).path].includes(to)) {
            dispatch('gaEvent', { evt, element, content, index, to: window.location.host + to }).then(() => {
              router.push(to)
            })
          } else {
            if (to.indexOf(basePath) >= 0) to = to.substring(to.indexOf(basePath) + 3)
            dispatch('gaEvent', { evt, element, content, index, to: window.location.host + to }).then(() => {
              router.push(to)
            })
          }
        } else if (
          [
            router.resolve({ name: 'signin' }).path,
            router.resolve({ name: 'signup' }).path,
            router.resolve({ name: 'buscar' }).path,
            router.resolve({ name: 'eventoPersonalizado' }).path
          ].includes(to)
          || to.indexOf(router.resolve({ name: 'eventoPersonalizado' }).path + '/') === 0
          || to.indexOf(router.resolve({ name: 'buscar' }).path) >= 0
        ) {
          dispatch('gaEvent', { evt, element, content, index, to: window.location.host + to }).then(() => {
            router.push(to)
          })
        } else if (typeof to === 'string' && (to.indexOf('http://') === 0 || to.indexOf('https://') === 0)) {
          dispatch('gaEvent', { element, content, index, to }).then(() => {
            window.open(to, '_blank')
          })
        } else
          return Promise.reject('N/D');
      } catch (e) {
        return Promise.reject('N/D');
      }
    },

    gaEvent({ state }, { element, content, index, to }) {
      if (content == 'banner')
        googleAnalyticsEvent(['lgfamilyclub', element, content, index, to])
      else {
        googleAnalyticsParamEvent(['lgfamilyclub', element, content, index, to])
      }
    }
  },
  mutations: {
  },
  getters: {
  },
};
